import React from 'react'
import _ from 'lodash'
import { C } from 'xadmin-ui'
import { use, app } from 'xadmin'
import { SchemaForm } from 'xadmin-form'
import { _t } from 'xadmin-i18n'
import { Form, Button, Modal, Tooltip } from 'antd'
import { EditOutlined, EyeOutlined, FilePdfOutlined } from '@ant-design/icons'
import DetailView from './DetailView'
import PDFButton from './PDFButton'

const ActionModalView = props => {
  const id = props?.id
  const [show, setShow] = React.useState(false)

  const onCancel = () => {
    setShow(false)
  }

  const onView = (e) => {
    setShow(true)
  }

  const viewModal = show && <Modal
    width='100%'
    visible={show}
    style={{ top: 0, maxWidth: '100%', padding: 0 }}
    bodyStyle={{ height: 'calc(100vh - 55px)' }}
    onCancel={onCancel}
    title={props?.name || '查看'}
    footer={null}
  >
    <PDFButton pdf={props.pdf} />
    <DetailView id={id} />
  </Modal>

  return [
    <Tooltip placement="top" title={props?.name || '查看'}>
      <Button key="action-edit" size="small" className="model-list-action" onClick={onView}>
        { props.pdf ? <FilePdfOutlined /> : <EyeOutlined /> }
      </Button>
    </Tooltip>, viewModal
  ]
}

const ActionModalEdit = props => {
  const { model, rest, modelDispatch } = use('model')
  const message = use('message')
  const { canEdit } = use('model.permission')
  const { saveItem } = use('model.save', props)
  const { getItems } = use('model.getItems', props)
  const id = props.id

  const [show, setShow] = React.useState(false)
  const [state, setState] = React.useState(() => ({ data: null, loading: false }))
  const { data, loading } = state
  const hideLoading = React.useRef()

  const onSubmitSuccess = (item) => {
    setShow(false)
    setState({ data: null, loading: false })
    getItems()
  }

  const onCancel = () => {
    setShow(false)
    setState({ data: null, loading: false })
  }

  const onEdit = (e) => {
    setState({ data: null, loading: true })
    rest.get(id).then(payload => {
      setState({ data: payload, loading: false })
      setShow(true)
    })
  }

  React.useEffect(() => {
    if (message?.loading) {
      if (loading) {
        hideLoading.current = message?.loading(_t('Loading data'))
      } else if (hideLoading.current) {
        hideLoading.current()
        hideLoading.current = null
      }
    }
  }, [loading])

  if (!canEdit) return null

  const onSubmit = (vs) => {
    modelDispatch({ type: 'SELECT_CLEAR' })
    return saveItem(vs)
  }

  const editForm = (show && data && !loading) ? (
    <SchemaForm
      formKey={`model.modalform.${model.key}.${id}`}
      schema={model}
      initialValues={data}
      {...model.formProps}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
    >
      {props => <ModalLayout
        {...props}
        show={show}
        onClose={onCancel}
        title={model.title}
      />}
    </SchemaForm>
  ) : null

  return [
    <Tooltip placement="top" title={_t('Edit')}>
      <Button key="action-edit" size="small" className="model-list-action" onClick={onEdit}>
        <EditOutlined />
      </Button>
    </Tooltip>, editForm
  ]
}

const ModalLayout = ({ children, invalid, handleSubmit, submitting, title, show, onClose, saveText }) => {
  const { _t } = app.context

  return (
    <Modal visible={show} onClose={onClose}
      style={{ maxWidth: 960 }}
      width='45%'
      title={title}
      okText={saveText || _t('Save')}
      onOk={handleSubmit}
      okButtonProps={{ disabled: invalid, loading: submitting }}
      cancelText={_t('Cancel')}
      onCancel={onClose}
    >
      <Form onSubmit={handleSubmit}>{children}</Form>
    </Modal>
  )
}


export {
  ActionModalView,
  ActionModalEdit
}
